import { Link } from 'react-router-dom';

const sectionStyle = { marginTop: 28 };
const h2Style = { fontSize: 20, fontWeight: 700, marginBottom: 10 };
const pStyle = { color: '#374151', lineHeight: 1.7, fontSize: 14, marginBottom: 10 };
const liStyle = { color: '#374151', lineHeight: 1.7, fontSize: 14, marginBottom: 6 };

export default function TermsPage() {
  return (
    <div className="fade-up" style={{ maxWidth: 760, margin: '0 auto', padding: '40px 20px' }}>
      <Link to="/" style={{ fontSize: 12, color: '#6B7280', textDecoration: 'none' }}>← Back to Sungresh</Link>
      <h1 style={{ fontSize: 32, fontWeight: 800, marginTop: 16, marginBottom: 8 }}>Terms of Service</h1>
      <p style={{ color: '#6B7280', fontSize: 13, marginBottom: 24 }}>Last updated: September 14, 2026</p>

      <p style={pStyle}>
        These Terms of Service ("Terms") govern your access to and use of Sungresh
        (the "Service"), operated at sungresh.com. By creating an account or using the
        Service, you agree to be bound by these Terms.
      </p>

      <div style={sectionStyle}>
        <div style={h2Style}>1. Accounts</div>
        <p style={pStyle}>You must provide accurate information when creating an account and are responsible for keeping your login credentials secure. You must be at least 16 years old to use the Service.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>2. Free Trial and Credits</div>
        <p style={pStyle}>New accounts receive a free trial with a limited number of credits. Credits are consumed as you use tools within the Service, at the rate displayed for each tool. Unused credits do not roll over between billing periods unless stated otherwise on our Pricing page.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>3. Acceptable Use</div>
        <p style={pStyle}>You agree not to:</p>
        <ul style={{ paddingLeft: 20 }}>
          <li style={liStyle}>Use the Service for any unlawful purpose or in violation of any applicable law</li>
          <li style={liStyle}>Attempt to circumvent credit limits, rate limits, or security measures</li>
          <li style={liStyle}>Use automated means to scrape or overload the Service beyond normal use</li>
          <li style={liStyle}>Generate content that is defamatory, infringing, or intended to deceive (e.g., fraudulent reviews or spam)</li>
          <li style={liStyle}>Resell or redistribute access to the Service without our written permission</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>4. AI-Generated Content</div>
        <p style={pStyle}>
          Content generated by our Content Writer, AI Checker, and Humanizer tools is produced by
          third-party AI models (via Anthropic's Claude API). We do not guarantee the accuracy,
          originality, or fitness for any particular purpose of AI-generated output. You are
          responsible for reviewing and verifying any content before publishing or relying on it,
          including checking it against plagiarism and factual-accuracy standards relevant to your use case.
        </p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>5. Third-Party Data</div>
        <p style={pStyle}>Domain, keyword, backlink, and traffic data is sourced from third-party providers (such as DataForSEO). Where live data isn't configured or available, the Service may display clearly labeled estimated or illustrative data. We do not guarantee the completeness or real-time accuracy of any third-party data shown.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>6. Payment and Plans</div>
        <p style={pStyle}>Paid plans are billed on a recurring basis as described on our Pricing page. You may cancel at any time; cancellation takes effect at the end of the current billing period. We do not provide refunds for partial billing periods except where required by law.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>7. Intellectual Property</div>
        <p style={pStyle}>The Service, including its design, code, and branding, is owned by Sungresh. You retain ownership of content you input and of the output generated for you, subject to the terms of the underlying AI provider's usage policies.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>8. Termination</div>
        <p style={pStyle}>We may suspend or terminate your account if you violate these Terms. You may stop using the Service and delete your account at any time.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>9. Disclaimer of Warranties</div>
        <p style={pStyle}>The Service is provided "as is" without warranties of any kind, express or implied. We do not warrant that the Service will be uninterrupted, error-free, or free of harmful components.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>10. Limitation of Liability</div>
        <p style={pStyle}>To the maximum extent permitted by law, Sungresh shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>11. Changes to These Terms</div>
        <p style={pStyle}>We may update these Terms from time to time. Continued use of the Service after changes take effect constitutes acceptance of the revised Terms.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>12. Contact Us</div>
        <p style={pStyle}>Questions about these Terms? Contact us at <a href="mailto:support@sungresh.com" style={{ color: '#FF642D' }}>support@sungresh.com</a>.</p>
      </div>
    </div>
  );
}
